module.exports = __webpack_public_path__ + "img/2023-09_academic-excellence.6bccb2b8.jpg";